import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state: any): any => state.get('campaignsPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
export const selectError = createSelector(selectState, (state) => state.get('error'));

export const selectOptInStatusLoading = createSelector(selectState, (state) =>
  state.get('setOptInStatusLoading')
);
export const selectOptInStatusError = createSelector(selectState, (state) =>
  state.get('setOptInStatusError')
);
